import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useAllHistory } from "./apiHistory";
import ListShort from "components/ui/atoms/ListShort";
import HistoryListItemShort from "models/history/HistoryListItemShort";
import { useNavigate } from "react-router-dom";

const HistoryWidget = ({ userId }) => {
  const navigate = useNavigate();
  const [state, setState] = useState({
    filter: {
      user: userId,
      content_type_model: ["app.company", "notes.note", "app.people"],
      created_at__gte: dayjs().subtract(2, "week").format("YYYY-MM-DD"),
    },
    offset: 0,
  });
  const [fetchParams, setFetchParams] = useState(null);
  const { data: historyList, status } = useAllHistory(fetchParams);

  useEffect(
    () =>
      setFetchParams({
        ...state.filter,
        offset: state.offset,
      }),
    [state],
  );

  const handleClick = (history) => {
    return navigate(
      `/${history.content_type_model.split(".")[1]}/${
        history.content_object.id
      }`,
    );
  };

  return (
    <ListShort
      title="History"
      emptyMessage="No History"
      resource={historyList}
      resourceStatus={status}
      state={state}
      setState={setState}
      ListItemComponent={HistoryListItemShort}
      primaryClick={handleClick}
      pagination
    />
  );
};

export default HistoryWidget;
